import { gql } from "@apollo/client";
import { Box, Stack } from "@chakra-ui/react";
import { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

import { InvoiceForm } from "../../components/InvoiceForm";
import { PageTitle } from "../../components/Page";
import { Panel } from "../../components/Panel";
import { buildInvoicePagePath, RouteParams } from "../../config/routes";
import { useCreateInvoiceMutation } from "../../generated/graphql";
import { useSingleParam } from "../../hooks/useSingleParam";

export const CREATE_INVOICE = gql`
  mutation CreateInvoice($input: CreateInvoiceInput!) {
    createInvoice(input: $input) {
      id
    }
  }
`;

export const InvoiceCreationPage = () => {
  const navigate = useNavigate();
  const supplierSlug = useSingleParam(RouteParams.SupplierSlug, { required: true });

  const [createInvoice] = useCreateInvoiceMutation();

  return (
    <Fragment>
      <Helmet>
        <title>WMS | New Invoice</title>
      </Helmet>
      <Stack spacing={6} px={8} py={5}>
        <Stack width="100%" isInline justifyContent="space-between">
          <PageTitle>New Invoice</PageTitle>
        </Stack>

        <Panel maxWidth="900px">
          <Box px={8} py={5}>
            <InvoiceForm
              onSubmit={async (values) => {
                const { data } = await createInvoice({
                  variables: {
                    input: {
                      ...values,
                      supplierSlug,
                      net: values.net,
                      vat: values.vat,
                      gross: values.gross,
                    },
                  },
                });

                if (data?.createInvoice?.id) {
                  navigate(buildInvoicePagePath(supplierSlug, data.createInvoice.id));
                  return;
                }

                console.log("TODO: handle this");
              }}
            />
          </Box>
        </Panel>
      </Stack>
    </Fragment>
  );
};
